import React, { Component } from 'react';
import { Modal, Select, Input, message, Spin } from 'antd';
import CascaderCounty from '../../common/CascaderCounty';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';

const { Option } = Select;
const hospitalLevelOptions = ['三级甲等', '三级乙等', '三级丙等', '二级甲等', '二级乙等', '二级丙等', '一级甲等', '一级乙等', '一级丙等', '其他'];

class PendingCooperationModal extends Component {
    state = {
        params: {},
        visible: false,
        loading: false,
        isEdit: false,
        generalNameInput: '',
    }

    show = (record) => {
        const params = {
            hospitalPendingCooperationId: record ? record.hospitalPendingCooperationId : undefined,
            hospitalName: record ? record.hospitalName : '',
            generalNames: record ? (typeof record.generalNames === 'string' ? record.generalNames.split(',').filter(Boolean) : (record.generalNames || [])) : [],
            courtyardArea: record ? record.courtyardArea : '',
            hospitalLevel: record ? record.hospitalLevel : '',
            cityId: record && record.hospitalProvinceId ? [record.hospitalProvinceId, record.hospitalCityId, record.hospitalCountyId].filter(Boolean) : [],
            hospitalProvince: record ? record.hospitalProvince : '',
            hospitalCity: record ? record.hospitalCity : '',
            hospitalCounty: record ? record.hospitalCounty : '',
            hospitalAddress: record ? record.hospitalAddress : '',
            postCode: record ? record.postCode : '',
        };
        this.setState({ params, visible: true, isEdit: !!record });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    submit = () => {
        const { isEdit, params: { hospitalName, hospitalLevel, courtyardArea, hospitalAddress, postCode, cityId, generalNames } } = this.state;
        if (!hospitalName) { message.warning('请输入医院官方名称'); return; }
        if (!hospitalLevel) { message.warning('请选择医院等级'); return; }
        if (!cityId || cityId.length < 2) { message.warning('请选择省市县级行政区'); return; }
        if (!hospitalAddress) { message.warning('请输入详细地址'); return; }

        const [provinceId, hospitalCityId, hospitalCountyId] = cityId;
        const data = {
            hospitalName, hospitalLevel, courtyardArea, hospitalAddress, postCode,
            hospitalProvinceId: provinceId,
            hospitalCityId: hospitalCityId,
            hospitalCountyId: hospitalCountyId || '',
            generalNames: (generalNames || []).join(','),
        };
        if (isEdit) { data.hospitalPendingCooperationId = this.state.params.hospitalPendingCooperationId; }

        this.setState({ loading: true });
        const url = isEdit ? API_URL.hospital.pendingCooperationUpdate : API_URL.hospital.pendingCooperationAdd;
        $.sendRequest({
            method: 'POST', url, data, dataType: 'json',
            doneResult: res => {
                message.success(isEdit ? '修改成功' : '新增成功');
                this.setState({ loading: false }, () => { this.hide(); this.props.loadData(); });
            },
            errorResult: () => { this.setState({ loading: false }); }
        });
    }

    handleInputChange = (e, key) => {
        const { params } = this.state;
        params[key] = e.target.value;
        this.setState({ params });
    }

    handleSelectChange = (value, key) => {
        const { params } = this.state;
        params[key] = value;
        this.setState({ params });
    }

    handleCascaderCityChange = (value, selectedOptions) => {
        const { params } = this.state;
        let hospitalProvince = '', hospitalCity = '', hospitalCounty = '';
        if (selectedOptions && selectedOptions.length > 0) {
            hospitalProvince = selectedOptions[0] ? selectedOptions[0].label : '';
            if (selectedOptions.length > 1) hospitalCity = selectedOptions[1] ? selectedOptions[1].label : '';
            if (selectedOptions.length > 2) hospitalCounty = selectedOptions[2] ? selectedOptions[2].label : '';
        }
        params.cityId = value;
        params.hospitalProvince = hospitalProvince;
        params.hospitalCity = hospitalCity;
        params.hospitalCounty = hospitalCounty;
        this.setState({ params });
    }

    addGeneralName = () => {
        const { params, generalNameInput } = this.state;
        const name = (generalNameInput || '').trim();
        if (!name) {
            message.warning('请输入医院曾用名称');
            return;
        }
        const names = params.generalNames || [];
        if (names.length >= 3) {
            message.warning('最多添加三个曾用名');
            return;
        }
        if (names.includes(name)) {
            message.warning('该名称已存在');
            return;
        }
        names.push(name);
        params.generalNames = names;
        this.setState({ params, generalNameInput: '' });
    }

    removeGeneralName = (index) => {
        const { params } = this.state;
        const names = params.generalNames || [];
        names.splice(index, 1);
        params.generalNames = names;
        this.setState({ params });
    }

    handleGeneralNameInputChange = (e) => {
        this.setState({ generalNameInput: e.target.value });
    }

    handleGeneralNameKeyDown = (e) => {
        if (e.key === 'Enter') {
            this.addGeneralName();
        }
    }

    getContent = () => {
        const { params, visible, generalNameInput } = this.state;
        const { hospitalName, hospitalLevel, courtyardArea, hospitalAddress, postCode, cityId, generalNames } = params;
        const asterisk = <span style={{ color: 'red' }}>*</span>;
        const levelOptions = hospitalLevelOptions.map(i => <Option key={i}>{i}</Option>);
        return (
            <ul className="modal-list">
                <li className="modal-item">
                    <div className="item-left">{asterisk}医院官方名称:</div>
                    <div className="item-right">
                        <Input maxLength="120" value={hospitalName} style={{ width: 180 }} onChange={e => this.handleInputChange(e, 'hospitalName')} />
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left">医院曾用名称:</div>
                    <div className="item-right">
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <Input maxLength="120" style={{ width: 160 }} placeholder="请输入"
                                value={generalNameInput}
                                onChange={this.handleGeneralNameInputChange}
                                onKeyDown={this.handleGeneralNameKeyDown} />
                            <span style={{ marginLeft: 4, cursor: 'pointer', fontSize: 18, fontWeight: 'bold', color: '#1890ff', userSelect: 'none' }}
                                onClick={this.addGeneralName}>+</span>
                        </div>
                        {generalNames && generalNames.length > 0 && (
                            <div style={{ marginTop: 4 }}>
                                {generalNames.map((name, index) => (
                                    <div key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: 2 }}>
                                        <span style={{ marginRight: 4 }}>{name}</span>
                                        <span style={{ cursor: 'pointer', color: '#ff4d4f', fontWeight: 'bold', userSelect: 'none' }}
                                            onClick={() => this.removeGeneralName(index)}>-</span>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left">院区:</div>
                    <div className="item-right">
                        <Input maxLength="120" value={courtyardArea} style={{ width: 180 }} onChange={e => this.handleInputChange(e, 'courtyardArea')} />
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left">{asterisk}医院等级:</div>
                    <div className="item-right">
                        <Select style={{ width: 180 }} value={hospitalLevel || undefined} placeholder="请选择"
                            onChange={value => this.handleSelectChange(value, 'hospitalLevel')}>{levelOptions}</Select>
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left">{asterisk}省市县级行政区:</div>
                    <div className="item-right">
                        {visible && <CascaderCounty value={cityId} style={{ width: 182 }} onChange={this.handleCascaderCityChange} />}
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left">{asterisk}详细地址:</div>
                    <div className="item-right">
                        <Input maxLength="200" value={hospitalAddress} style={{ width: 180 }} placeholder="请输入" onChange={e => this.handleInputChange(e, 'hospitalAddress')} />
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left">邮编:</div>
                    <div className="item-right">
                        <Input maxLength="20" value={postCode} style={{ width: 180 }} placeholder="请输入" onChange={e => this.handleInputChange(e, 'postCode')} />
                    </div>
                </li>
            </ul>
        );
    }

    render() {
        const { isEdit, visible, loading } = this.state;
        return (
            <Modal
                title={isEdit ? '修改待合作医院' : '新增待合作医院'}
                visible={visible}
                onCancel={this.hide}
                onOk={this.submit}
                className="create-modal"
                wrapClassName="vertical-center-modal"
                confirmLoading={loading}
                maskClosable={false}
                width="480px"
            >
                <Spin spinning={loading}>
                    <div className="modal-content" style={{ padding: '0 20px' }}>{this.getContent()}</div>
                </Spin>
            </Modal>
        );
    }
}

export default PendingCooperationModal;



// WEBPACK FOOTER //
// ./src/components/hospital/hospitalInfo/PendingCooperationModal.js